'use client';

import clsx from 'clsx';
import { VpIcon } from '@vtmn-play/react';
import { CalloutProps } from './Callout.props';

import './Callout.scss';

const Callout = ({
  cardTitle,
  children,
  className,
  icon,
  ...rest
}: CalloutProps) => {
  return (
    <div className={clsx('callout', className)} {...rest}>
      {icon && <VpIcon name={icon} size={24} />}
      <div className='callout-content'>
        {cardTitle && <p className='callout-title'>{cardTitle}</p>}
        {children}
      </div>
    </div>
  );
};

export default Callout;
